module.exports = __webpack_public_path__ + "static/media/image1.6644464a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image1.png
// module id = 399
// module chunks = 0